"use client";

import Link from "next/link";
import { SheetClose } from "@/components/ui/sheet";
import React from "react";
import { usePathname } from "next/navigation";
import {
	isNavHrefActive,
	NAV_ICON_CLASS,
	navLabelClass,
} from "../nav-active";

export function MobileNavItem({
	href,
	icon,
	label,
}: {
	href: string;
	icon: React.ReactNode;
	label: string;
}) {
	const pathname = usePathname();
	const isActive = isNavHrefActive(pathname, href);

	return (
		<SheetClose asChild>
			<Link
				href={href}
				className="grid grid-cols-[1.5rem_150px] justify-start items-center gap-3 text-xl w-full cursor-pointer"
				aria-current={isActive ? "page" : undefined}
			>
				<span className={`flex justify-center ${NAV_ICON_CLASS}`}>{icon}</span>
				<span className={`w-[200px] truncate ${navLabelClass(isActive, true)}`}>
					{label}
				</span>
			</Link>
		</SheetClose>
	);
}
